var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useTranslation } from '@kb/i18n';
import Button, { ButtonDisplayType, ButtonSize } from '@ocp/button';
import Modal, { ModalSize } from '@ocp/modal';
import i18nKeys from '../../i18n/index';
import { useAddToComparisonMutation, useClearComparisonMutation } from '../../mutations/index';
const ComparisonNotification = ({ classNameId, classPk, comparisonPageUrl = '', visible, onClose, }) => {
    const { t } = useTranslation();
    const [clearComparison] = useClearComparisonMutation();
    const [addToComparison] = useAddToComparisonMutation(classNameId, classPk, t(i18nKeys.PREVIOUS_COMPARISON_CLEARED_AND_SELECTED_CONTENT_ADDED), comparisonPageUrl);
    const handleClearComparisonClick = () => __awaiter(void 0, void 0, void 0, function* () {
        yield clearComparison();
        yield addToComparison();
        onClose();
    });
    const buttons = (React.createElement(React.Fragment, null,
        React.createElement(Button, { displayType: ButtonDisplayType.Tertiary, size: ButtonSize.Small, onClick: () => onClose() }, t(i18nKeys.CANCEL)),
        React.createElement(Button, { displayType: ButtonDisplayType.Primary, size: ButtonSize.Small, onClick: handleClearComparisonClick }, t(i18nKeys.CLEAR_LIST))));
    return (React.createElement(Modal, { buttons: buttons, center: true, size: ModalSize.Small, visible: visible, onClose: onClose }, t(i18nKeys.COMPARISON_CONTAINS_CONTENT_OF_DIFFERENT_STRUCTURE_WANT_TO_CLEAR)));
};
export default ComparisonNotification;
